import { notificacaoErro } from "../app/notificacao";

async function fetchAtualizaUsuario(body, token, id) {
  const url = new URL(process.env.REACT_APP_API_URL + "/usuario/" + id);
  const init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  };

  const fet = await fetch(url, init);

  switch (fet.status) {
    case 200:
      return { success: true, status: fet.status, data: await fet.json() };
    case 404:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro ao atualizar o usuário."),
      };
    default:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro inesperado ao atualizar o usuário."),
      };
  }
}

const atualizaUsuario = { fetchAtualizaUsuario };

export default atualizaUsuario;
